import React, { useState } from "react";
import { Box } from "@mui/material";

function isValidEmail(value) {
  return /\S+@\S+\.\S+/.test(value);
}

export default function SignupForm({ className = "" }) {
  const [email, setEmail] = useState("");
  const [newsletterOptIn, setNewsletterOptIn] = useState(false);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const formClassName = ["cta-form", className].filter(Boolean).join(" ");
  const MC_ACTION =
    "https://showkompass.us16.list-manage.com/subscribe/post?u=6181d0a84ad9c7219033badec&id=e0f5b82a74&f_id=001692e1f0";
  const MC_HONEYPOT = "b_6181d0a84ad9c7219033badec_e0f5b82a74";
  const MC_JSONP = MC_ACTION.replace("/post?", "/post-json?");

  function stripHtml(value) {
    return value.replace(/<[^>]*>/g, "").trim();
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!isValidEmail(email)) {
      e.preventDefault();
      setError("Bitte gib eine gültige E-Mail-Adresse ein.");
      return;
    }

    if (!newsletterOptIn) {
      e.preventDefault();
      setError("Bitte bestätige den Newsletter-Opt-in.");
      return;
    }

    setStatus("loading");

    const callbackName = `mc_callback_${Date.now()}`;
    const script = document.createElement("script");
    const params = new URLSearchParams({
      EMAIL: email,
      c: callbackName,
    });
    script.src = `${MC_JSONP}&${params.toString()}`;
    script.async = true;
    script.onerror = () => {
      delete window[callbackName];
      script.remove();
      setStatus("error");
      setError("Die Verbindung zu Mailchimp ist fehlgeschlagen. Bitte später nochmal versuchen.");
    };

    window[callbackName] = (data) => {
      delete window[callbackName];
      script.remove();

      if (data?.result === "success") {
        setStatus("success");
        return;
      }

      const message = data?.msg ? stripHtml(data.msg) : "Ups, das hat nicht geklappt.";
      setStatus("error");
      setError(message);
    };

    document.body.appendChild(script);

    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", { source: "landingpage_cta" });
    }
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture("landingpage_cta_submit", { source: "landingpage_cta" });
    }
  }

  return (
    <form
      className={formClassName}
      onSubmit={handleSubmit}
      noValidate
    >
      {status === "success" ? (
        <Box
          sx={{
            px: 2.2,
            py: 1.6,
            borderRadius: 2,
            bgcolor: "rgba(16,185,129,0.12)",
            color: "success.main",
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          Wir haben dir eine Mail gesendet.
        </Box>
      ) : (
        <>
          <input
            className="cta-input"
            type="email"
            name="EMAIL"
            placeholder="Deine E-Mail-Adresse"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
              if (status === "success" || status === "error") {
                setStatus("idle");
              }
            }}
            disabled={status === "loading"}
            aria-label="E-Mail-Adresse"
          />

          <button type="submit" className="cta-button" disabled={status === "loading"}>
            {status === "loading" ? "Wird gesendet…" : "Jetzt loslegen"}
          </button>

          <label className="cta-consent">
            <input
              type="checkbox"
              required
              checked={newsletterOptIn}
              onChange={(e) => {
                setNewsletterOptIn(e.target.checked);
                setError("");
                if (status === "success" || status === "error") {
                  setStatus("idle");
                }
              }}
              disabled={status === "loading"}
            />
            <span>Ja, ich möchte den E-Mail-Newsletter von Showkompass mit Tipps zum Musikbusiness erhalten.</span>
          </label>
        </>
      )}

      <div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
        <input type="text" name={MC_HONEYPOT} tabIndex="-1" defaultValue="" />
      </div>

      {error && <span className="cta-feedback error">{error}</span>}
    </form>
  );
}
